import React, { useState } from 'react';
import {
  AppBar,
  Checkbox,
  IconButton,
  InputBase,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Paper,
  Typography,
  Box,
  ListItemSecondaryAction,
  useMediaQuery,
} from '@material-ui/core';
import { Delete, PostAdd } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    height: '100vh',
    paddingTop: '6rem',
    boxSizing: 'border-box',
    backgroundColor: '#f5f5f5',
  },
  searchPaper: {
    padding: '10px 15px',
    marginBottom: '10px',
  },
});

const Main = () => {
  const classes = useStyles();
  const mobile = useMediaQuery('(max-width: 500px)');

  const [todos, setTodos] = useState([]);
  const [text, setText] = useState('');
  const addTodo = () => {
    if (text?.trim()) {
      const data = {
        id: Math.ceil(Math.random() * 10000),
        text,
        isDone: false,
      };
      setTodos((old) => [data, ...old]);
      setText('');
    }
  };
  const updateState = (id, isDone) =>
    setTodos((old) =>
      old.map((todo) => (todo.id === id ? { ...todo, isDone } : todo))
    );
  const deleteTodo = (id) =>
    setTodos((old) => old.filter((todo) => todo.id !== id));

  return (
    <Box className={classes.root}>
      <Box mx="auto" width={mobile ? '80%' : '50%'}>
        <AppBar>
          <Typography
            align="center"
            variant={mobile ? 'h4' : 'h3'}
            gutterBottom
          >
            Material UI Todo App
          </Typography>
        </AppBar>
        <Paper className={classes.searchPaper}>
          <InputBase
            placeholder="What you want to do?"
            endAdornment={
              <InputAdornment>
                <IconButton edge="end" onClick={addTodo}>
                  <PostAdd />
                </IconButton>
              </InputAdornment>
            }
            value={text}
            onKeyPress={(e) => (e.code === 'Enter' ? addTodo() : null)}
            onChange={(e) => setText(e.target.value)}
            fullWidth
          />
        </Paper>
        <List>
          {todos.map(({ id, isDone, text }) => (
            <ListItem
              key={id}
              button
              divider
              onClick={(e) => updateState(id, !isDone)}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={isDone}
                  onChange={() => updateState(id, !isDone)}
                />
              </ListItemIcon>
              <ListItemText primary={text} />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="comments"
                  onClick={() => deleteTodo(id)}
                >
                  <Delete />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default Main;
